module.exports = {"toClipboard":"Copiar","copied":"Copiado","notCopied":"Não foi copiado"};